import { openModal } from '@core/components/ModalStack';
import { SelectEstimateModalProps } from './SelectEstimateModal';

export async function openSelectEstimateModal(props: SelectEstimateModalProps) {
  const { SelectEstimateModal } = await import('./SelectEstimateModal');

  openModal(SelectEstimateModal, props);
}
